import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import 'intl-tel-input';
import { CustomValidators } from "../shared/utility/custom-validator";
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AjaxService } from '../services/ajax.service';
import { Utility } from '../shared/utility/utility';
import { CountryDataService } from '../services/country.service';
import { UserDetailsService } from '../services/user-details.service';
import { EmitterService } from '../services/emitter.service';
import { FormValidationComponent } from '../form-validation/form-validation.component';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ZendeskService } from "../services/zendesk.servcie";
import * as $ from 'jquery';
import { environment } from '../../environments/environment';
import { AppDetailsService } from '../services/app-details.services';
window['$'] = window['jQuery'] = $;
import { countryUserCurrencies, restOfTheWorldCurrencies, language, policiesTypes } from '../shared/utility/config';
import { Router } from '@angular/router';
import { BannerService } from '../services/banner.service';
import { SocketService } from '../services/socket.service';
import { PoliciesVersionService } from '../services/policies-version.service';
import { Utilities } from '../services/utilities.services';
@Component({
  selector: 'app-create-account-pnp',
  templateUrl: './create-account-pnp.component.html',
  styleUrls: ['./create-account-pnp.component.scss']
})
export class CreateAccountPnpComponent extends FormValidationComponent implements OnInit {
  registerData = {
    "language":"",
    "emailId":"",
    "phone":"",
    "currencyCode":"",
    "screenName":"",
    "password":"",  
    "areaCode":"",  
    "areaCountryCode":"" ,
    "termsNcondition":false,
    "country":""
  }
  viewPassword = false;
  focuspassword = false; 
  langCode;
  message= "";
  showResetPassword = false;
  ipCountry: any;
  availableCurrency;
  iRegisterButtonClicked = false;
  @Output() goToZimplerIfram = new EventEmitter<any>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  configuredPolicesData:Array<Object>=[];
  clonedPoliciesTypes;
  isZendeskEnabled = environment.zendeskServiceConfig["isEnabled"];
  zimplerRegistrationForm = this.formBuilder.group({
      'emailId': ['', {updateOn: 'blur', validators:[this.CustomValidators.validateUniqueness("txtEmail", this.ajaxService, false)]}],
      'password': ['', this.CustomValidators.validatePassword(8)],
      'areaCode': ['', this.CustomValidators.required],
      'areaCountryCode': ['', this.CustomValidators.required],
      'currencyCode': ['', this.CustomValidators.required],
      'phoneNumber': ['', [this.CustomValidators.phoneNumberValidator]],
      'termsAndCondition': [true, [this.CustomValidators.required]],
    }, { validator: this.CustomValidators.validateCheckMobile(this.ajaxService, false, "") })

  constructor(
    private formBuilder: FormBuilder, private CustomValidators: CustomValidators, 
    private ajaxService:AjaxService, 
    private utils: Utility,
    private countryDetails:CountryDataService, 
    private socketService:SocketService,
    private userDetailsService:UserDetailsService, private emitterService:EmitterService,
    private appDetails:AppDetailsService,
    private zenDesk:ZendeskService,private router:Router, private bannerService:BannerService,
    private policiesVersionService:PoliciesVersionService,
    private utilities: Utilities) { 
      super(utils);
      this.emitterService.userCountry$.pipe(takeUntil(this.destroy$)).subscribe(country => {
        this.ipCountry = country
        this.setCountryCodeData()
      });
      this.clonedPoliciesTypes = Object.values(policiesTypes);
    }

  ngOnInit() {
    this.langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en';
    this.getCountry();
    this.getPolicies();
    this.checkFormValuesChanged();
  }
  getCountry() {

    Promise.resolve(this.countryDetails.getCountriesDetails()).then(regData => {
      this.initialstep();
    });
  }
  trimPassowrd(){
    let password = this.zimplerRegistrationForm.controls['password'].value;
    this.zimplerRegistrationForm.controls['password'].setValue(password.trim())
  }
  getValidFormContols(formGroup: FormGroup, validControls) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl && control.valid && field !== this.focusedElement) {
        validControls.push(field)
      } else if (control instanceof FormGroup) {
        this.getValidFormContols(control, validControls);
      }
    });
    return validControls;
  }
  shouldShowPwdError(fieldName, formName) {
    return this.utils.shouldShowErrors(fieldName, formName)
  }

  // New registration mobile disable submit button
  getButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName)
  }
  getErrorMessage(fieldName, formName) {
    return this.utils.getErrorMessage(fieldName, formName);
  }
  getPolicies() {
    this.policiesVersionService.getPolicies().pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data && data['status'] === "SUCCESS") {
        this.configuredPolicesData = data['policyConfigs'];
      }
    })
  }
  registerUser(){
    this.iRegisterButtonClicked = true;
    this.showResetPassword = false;
    if(this.zimplerRegistrationForm.valid){
      let newUserData = this.updateRegistrationData(this.zimplerRegistrationForm);
      localStorage.setItem("registerUserData",JSON.stringify(newUserData))
      let emailId = this.zimplerRegistrationForm.controls['emailId'].value;
      let password = this.zimplerRegistrationForm.controls['password'].value;
   let self = this;
    let credentials = {}
    credentials["emailId"] = emailId.trim()
    credentials["password"] = password.trim();
    let registerData = this.updateRegistrationData(this.zimplerRegistrationForm);
    if (this.configuredPolicesData && this.configuredPolicesData.length > 0 && environment.pnpCountryList.indexOf(this.ipCountry) >= 0) {
      registerData["policies"] =  this.policiesVersionService.sendNewUpdatedPolicy(true);
    }
    Promise.resolve(this.ajaxService.doLogin(credentials))
      .then(loginData => {
        if(loginData['errors'] && loginData['errors']['errorCode'] === 100166){
          
         Promise.resolve(this.ajaxService.doRegistration(registerData)).then(response => {
          if(response && response['success'] == true){
           let ecrIdRegister = response['ecrId'];
           Promise.resolve(this.ajaxService.doLogin(credentials)).then((res) =>{
            if(res && res['success'] == true){
              this.emitterService.broadCastJurisdictionValue(res["userJurisdiction"]);
              let userData = {
                ecrId:ecrIdRegister,
                newUser:true
              }
              this.goToZimplerIfram.emit(userData); 
              this.router.navigate([this.langCode]);
              self.updateUserStatus(true,res,registerData,ecrIdRegister);
            }
           })
          }
          
        })
        }else if(loginData && loginData['success'] == true){
          this.emitterService.broadCastJurisdictionValue(loginData["userJurisdiction"]);
          Promise.resolve(this.ajaxService.getProfileData())
          .then(profileDetails => {
            let ecrId = loginData['user']['id'].substr(3);
            if(environment.semiPnpZimplerCountries.indexOf(profileDetails['country'])>=0){
              this.emitterService.broadCastUserCountryPNP(profileDetails['country'])
              this.updateUserStatus(true,loginData,registerData,ecrId);
              let userData = {
               ecrId:ecrId,
               newUser:false
             }
              this.goToZimplerIfram.emit(userData); 
              this.router.navigate([this.langCode]);
            }else{
              this.emitterService.broadCastUserCountryPNP(profileDetails['country'])
              this.updateUserStatus(true,loginData,registerData,ecrId);
              this.utils.closeModal("pnpDepositModal");
              this.router.navigate([this.langCode])
            }
          })
         
        }else if(loginData['errors'] && loginData['errors']['errorCode'] === 100161){
          this.showResetPassword = true;
        }
      })

  }else{
    Object.keys(this.zimplerRegistrationForm.controls).forEach(key => {
      this.zimplerRegistrationForm.controls[key].markAsDirty();
     });
     return;
  }
}
checkFormValuesChanged(){
  this.zimplerRegistrationForm.valueChanges.subscribe(selectedValue  => {
    this.showResetPassword = false; 
  })
}


updateUserStatus(isRegistration = false, loginData, signUpData,ecrId){
  localStorage.setItem("gtmLoggedInEvent", "login");
  this.userDetailsService.setUserLangCode(loginData['language'], this.langCode);
  if(isRegistration){
    sessionStorage.setItem("user",'true')
    /*GTM event for user registration */
    this.utils.gtmEvent("userRegistered", {
      email: signUpData["emailId"],
      userExternalECR: ecrId,
      username: signUpData["screenName"]
    });
     /*For Server to Server calls for cpl */
     this.utils.S2Scalls(signUpData, "registration");
  
  }else{
    this.socketService.connectToScoket(
      loginData["pragmaticUrl"],
      loginData["pragmaticSessionId"]
    );
    this.emitterService.broadcastLoginStatus(true);
  }

  this.emitterService.broadcastLoadHomeBanner("userLoggedInn");
  this.emitterService.broadcastloginComplete(ecrId ? "pnpUserLogged":"loginsuccess");
  localStorage.setItem("loginstatus", "true");
  this.bannerService.clearBanners();
}
toggleZDChat() {
  this.utilities.initChat();
}
initialstep() {
  let avCurrencyData = this.appDetails.getAvailableCurrencies();
  if (avCurrencyData) {
    this.setFirstStepReqData(avCurrencyData);
  } else {
    Promise.resolve(this.countryDetails.getEnabledCurrencies()).then(currencyData => {
      this.appDetails.setAvailableCurrencies(currencyData);
      this.setFirstStepReqData(currencyData);
    },
    SystemError => {
    });
  }
}
resetPassword(){
  this.showResetPassword = false;
  this.emitterService.broadcastModalState({ name: "pnpDepositModal", state: "close" });
  this.utils.forgotPassword();
}
setFirstStepReqData(currencyData) {
  this.ipCountry = this.countryDetails.ipCountry;

  if(!this.zimplerRegistrationForm.controls["areaCountryCode"].value) this.zimplerRegistrationForm.controls["areaCountryCode"].setValue(this.ipCountry);
  
  let validCurrency=[];
  if (currencyData && currencyData["currency"]) {
    validCurrency = currencyData["currency"];
  }

  this.availableCurrency = validCurrency.length>0?restOfTheWorldCurrencies.filter(c=>validCurrency.includes(c)):restOfTheWorldCurrencies;
  
  const configCountries=countryUserCurrencies.flatMap(c=>c.countries);

  if(configCountries.includes(this.ipCountry)){
    const configCountry=countryUserCurrencies.find(c=>c.countries.includes(this.ipCountry));
    if (configCountry!==undefined) {
      this.availableCurrency = validCurrency.length>0?configCountry["currencies"].filter(c=>validCurrency.includes(c)):configCountry["currencies"];
    }

  }

  if(this.availableCurrency.length<=0){
    this.zimplerRegistrationForm.controls["currencyCode"].setValue(restOfTheWorldCurrencies[0]);
  }else{
    this.zimplerRegistrationForm.controls["currencyCode"].setValue(this.availableCurrency[0]);
  }

  setTimeout(() => {
    this.utils.setPhoneNumberDropdown("phoneNumberFlag", this.zimplerRegistrationForm.controls["areaCountryCode"].value, this.zimplerRegistrationForm);
    if (!this.zimplerRegistrationForm.controls["areaCode"].value) this.zimplerRegistrationForm.controls["areaCode"].setValue($("#phoneNumberFlag").intlTelInput("getSelectedCountryData").dialCode);
  }, 100);
}
setCountryCodeData() {
  if (!this.zimplerRegistrationForm.controls["areaCountryCode"].value) this.zimplerRegistrationForm.controls["areaCountryCode"].setValue(this.ipCountry);
  /*Settimeout used for HTML to be loaded and then "phoneNumberFlag" field can be captured*/
  setTimeout(() => {
    this.utils.setPhoneNumberDropdown("phoneNumberFlag", this.zimplerRegistrationForm.controls["areaCountryCode"].value, this.zimplerRegistrationForm);
    if (!this.zimplerRegistrationForm.controls["areaCode"].value) this.zimplerRegistrationForm.controls["areaCode"].setValue($("#phoneNumberFlag").intlTelInput("getSelectedCountryData").dialCode);
  }, 100);

}
trimPassword(){
  
}
updateRegistrationData(form){

   /*Clean the form of unnecessary spaces*/
   this.zimplerRegistrationForm = this.userDetailsService.cleanForm(this.zimplerRegistrationForm);
   this.registerData.emailId = this.zimplerRegistrationForm.controls['emailId'].value;
   this.registerData.screenName = this.zimplerRegistrationForm.controls['emailId'].value;
   this.registerData.phone = this.zimplerRegistrationForm.controls['phoneNumber'].value;
   this.registerData.password = this.zimplerRegistrationForm.controls['password'].value;
   this.registerData.termsNcondition = this.zimplerRegistrationForm.controls['termsAndCondition'].value;
   this.registerData.areaCode = this.zimplerRegistrationForm.controls['areaCode'].value;
   this.registerData.areaCountryCode = this.zimplerRegistrationForm.controls['areaCountryCode'].value;
   this.registerData.currencyCode = this.zimplerRegistrationForm.controls['currencyCode'].value; ;
   this.registerData.language = language[this.langCode];
   this.registerData.country = this.ipCountry;
   this.registerData['affiliateId'] = this.utils.getAffliateId('affiliate');
   this.registerData['affiliateName'] = this.utils.getAffliateId('affiliatename');
   this.registerData['emailAndMobileSubscribed'] = true;
   this.registerData['trackerId'] = this.utils.getAffliateId('tracker');
  
   return this.registerData
}
}
